import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { founderApi } from '@/lib/founderApi';
import { errMsg } from '@/lib/digitalApi';
import { usePageMeta } from '@/lib/usePageMeta';
import { FounderFrame } from '@/components/founder/FounderFrame';

// Sign-in requires a click so email link scanners cannot consume the single-use token.
export default function FounderVerify() {
  usePageMeta({ title: 'Opening your Workspace', path: '/founder/verify', robots: 'noindex' });
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [state, setState] = useState({});

  const open = async () => {
    setState({ loading: true });
    try {
      await founderApi.verify(token);
      navigate('/founder/workspace', { replace: true });
    } catch (err) {
      setState({ error: errMsg(err, 'This sign-in link is invalid, expired, or has already been used.') });
    }
  };

  return (
    <FounderFrame eyebrow="ORIGENNE™ · Founder Workspace" testid="founder-verify-page">
      <h1 className="font-serif-display text-5xl md:text-6xl tracking-tighter text-matte leading-[1.02]">
        Welcome <em className="italic text-taupe">back.</em>
      </h1>
      {state.error ? (
        <>
          <p className="mt-6 text-matte/70" data-testid="founder-verify-error">{state.error}</p>
          <Link to="/founder/login" className="btn-primary mt-10" data-testid="founder-verify-new-link">Request a New Link</Link>
        </>
      ) : (
        <>
          <p className="mt-6 text-matte/70 leading-relaxed">Select the button below to securely open your Founder Workspace on this device.</p>
          <button onClick={open} disabled={!token || state.loading} className="btn-primary mt-10" data-testid="founder-verify-open-button">
            {state.loading && <Loader2 size={14} className="animate-spin" />} Open My Workspace
          </button>
          {!token && <p className="mt-4 text-sm text-red-700" data-testid="founder-verify-missing">This link is missing its sign-in code.</p>}
        </>
      )}
    </FounderFrame>
  );
}
